export function scrollIntoViewWithOffset(selector) {
  setTimeout(() => {
    const y = document.getElementById(selector).getBoundingClientRect().top;
    window.scrollTo({
      top: y - 80,
      behavior: 'smooth'
    }
  )}, 300)
}